import PropTypes from 'prop-types';
import { Tooltip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

EditIconButton.propTypes = {
  onClick: PropTypes.func,
  tooltipText: PropTypes.string,
  disableRipple: PropTypes.bool
};

export default function EditIconButton({ onClick, tooltipText = "Edit", disableRipple = false }) {
  return (
    <Tooltip title={tooltipText} arrow>
      <IconButton edge="end" color="secondary" onClick={onClick} disableRipple={disableRipple} sx={disableRipple ? { p: 0, mr: 0.5 } : { mr: 0.5 }}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
}
